import { bindModalAction, createModalOverlay } from './modalBase';

export const showRenameProjectModal = (
  currentName: string,
  onConfirm: (newName: string) => void
): void => {
  const { overlay, close } = createModalOverlay(`
    <div class="modal-content">
      <h3 class="modal-title">Rename Session</h3>
      <input type="text" class="modal-input" placeholder="Session name" />
      <div class="modal-actions">
        <button class="modal-btn modal-btn-cancel">Cancel</button>
        <button class="modal-btn modal-btn-confirm">Rename</button>
      </div>
    </div>
  `);

  const input = overlay.querySelector('.modal-input') as HTMLInputElement | null;
  if (!input) return;

  input.value = currentName;

  requestAnimationFrame(() => {
    input.focus();
    input.select();
  });

  const confirmRename = (): void => {
    const newName = input.value.trim();
    if (newName) {
      close();
      onConfirm(newName);
    }
  };

  bindModalAction(overlay, '.modal-btn-cancel', close);
  bindModalAction(overlay, '.modal-btn-confirm', confirmRename);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      confirmRename();
    }
  });
};
